import React, { FC } from 'react';
import { ReactComponent as Calendar } from 'src/assets/images/calendar.svg';
import styled from 'styled-components';
import history from '../../config/browser-history';
import { URL_DATE_FORMAT } from '../../constants/dates';
import { ordersRoute } from '../../pages/orders/route';
import { Grey } from '../../styles/colours';
import { DatePickerInputStyle } from '../date-range-picker/date-range-input-styles';
import {
  DateRangePicker,
  IDateProps,
} from '../date-range-picker/date-range-picker';

const StyledDateRangeSearchForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 2.2rem;
  margin-left: 0.5rem;

  a {
    font-family: AvenirNext;
    font-size: 1rem;
    margin-top: 0.5rem;
  }
`;

export const CalendarContainer = styled.div`
  display: inline-flex;
  border: none;
  outline: none;
  align-items: center;
`;

export const StyledContainer = styled.div`
  display: inline-flex;
  border: 0.125rem solid ${Grey};
  border-radius: 0.25rem;
  padding-right: 1rem;
`;

export const DateRangeSearchForm: FC<{
  soldToId: string;
  shipToId?: string;
}> = ({ soldToId, shipToId }) => {
  const handleDateChange = (value: IDateProps) => {
    if (value && value.startDate && value.endDate) {
      history.push(
        ordersRoute(soldToId, {
          shipToId,
          start: value.startDate.format(URL_DATE_FORMAT),
          end: value.endDate.format(URL_DATE_FORMAT),
        })
      );
    }
  };

  return (
    <StyledDateRangeSearchForm data-type="date-picker">
      <StyledContainer>
        <DatePickerInputStyle>
          <DateRangePicker
            initialRange={{
              startDate: null,
              endDate: null,
            }}
            onChange={handleDateChange}
            anchorDirection="right"
          />
        </DatePickerInputStyle>
        <CalendarContainer>
          <Calendar />
        </CalendarContainer>
      </StyledContainer>
    </StyledDateRangeSearchForm>
  );
};
